var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('v-icon',{attrs:{"size":"1.75rem"}},[_vm._v(" mdi-check-circle ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }